import React from 'react';
import { Link as PrismicLink, RichText } from 'prismic-reactjs'
import { Link } from 'gatsby';
import { linkResolver } from '../utils/linkResolver';

const htmlSerializer = (type, element, content, children, index) => {
    // Generate links to Prismic Documents as <Link> components
    if (type === 'hyperlink') {
        let result = ''
        const url = PrismicLink.url(element.data, linkResolver)
        if (element.data.link_type === 'Document') {
            result = <Link to={url} key={index}>{content}</Link>
        } else {
            const target = element.data.target ? { 'target': element.data.target, 'rel': 'noopener' } : {}
            result = <a href={url} {...target} key={index}>{content}</a>
        }
        return result
    }

    if (type === 'paragraph') {

        
        if(element.text == ""){
            return <br/>
        }

    }    

    // If the image is also a link to a Prismic Document, it will return a <Link> component
    if (type === 'image') {

        let result =

            <picture>
                <source type="image/webp" srcSet={element.url} />
                <img src={element.url.split('?')[0]} alt={element.alt || ''} copyright={element.copyright || ''} />
            </picture>


        if (element.linkTo) {
            const url = PrismicLink.url(element.linkTo, linkResolver)

            if (element.linkTo.link_type === 'Document') {
                result = <Link to={url} key={index}>{result}</Link>
            } else {
                const target = element.linkTo.target ? { 'target': element.linkTo.target, 'rel': 'noopener' } : {}
                result = <a href={url} {...target}>{result}</a>
            }
        }

        if (element.label == 'fullscreen-img') {
            result =
                <div key={index} className="fullscreen-img">

                    <img src={element.url} alt={element.alt || ''} copyright={element.copyright || ''} />

                </div>
        } else {
            const wrapperClassList = [element.label || '', 'block-img'];
            result = <p className={wrapperClassList.join(' ')} key={index}>{result}</p>
        }
        return result;
    }
    if (element['label'] == "blockquote") {


        let result =
            <blockquote key={index}>
                {element.spans && element.spans[0] && element.spans[0].start &&
                    <div>
                        {element.text.substring(0, element.spans[0].start)}
                    </div>
                }

                {!element.spans[0] &&

                    <div>
                        {element.text}
                    </div>
                }

                {element.spans[0] && element.spans[0].start && element.spans[0].end &&
                    <em>{element.text.substring(element.spans[0].start, element.spans[0].end)}</em>}

            </blockquote>
        return result;
    }

    // Return null to stick with the default behavior for everything else
    return null;
};

const RichTextCustom = ({ render }) => {
    return (
        <RichText
            render={render}
            linkResolver={linkResolver}
            htmlSerializer={htmlSerializer} />
    );
}

export default RichTextCustom;